import React from 'react';
import { Box } from '@chakra-ui/react';
import styled from 'styled-components';
import {formatAddress } from '../../../utils/helper';

const TDItem = styled.td`
  padding: 10px 12px;
`;

export default function RewardItem({ item, rank, yourData }) {
  return (
    <tr className={yourData !== null && yourData?.address === item.address ? "highline": ""}>
      <TDItem>
        <Box fontSize='16px' textAlign='center' color='#ccc'>
          {formatAddress(item.address)}
        </Box>
      </TDItem>
      <TDItem>
        <Box fontSize='16px' textAlign='center' color='#ccc'>
          {item?.total?.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} WANA
        </Box>
      </TDItem>
      <TDItem>
        <Box fontSize='16px' textAlign='center' color='#ccc'>
          {rank}
        </Box>
      </TDItem>
    </tr>
  );
}
